<template>
  <div class="brands-container">
    <div class="brands-title">
      <h1>NOS MARQUES</h1>
      <div class="breadcrumb">
        <a href="/">Accueil</a> > <a href="/marques">Marques</a>
      </div>
    </div>
    <div class="supracare-description">
      <link href="https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;700&family=Open+Sans:wght@300;400;600&display=swap" rel="stylesheet">

      <h2>Marques de confiance</h2>
      <p>
        Supracare travaille en partenariat avec des marques reconnues mondialement pour fournir les produits les plus fiables et de la meilleure qualité.
      </p>

      <h2>Nos Partenaires</h2>
      <p>
        Nous collaborons avec des entreprises leaders dans l'industrie, garantissant ainsi la fiabilité des produits proposés.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrandsPage',
};
</script>

<style scoped>
.brands-container {
  padding: 0px 0px;
  background-color: #f9f9f9;
  text-align: justify;
  z-index: 1;
  overflow: hidden;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.brands-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: -1;
}

.brands-title {
  position: relative;
  background-image: url('C:/Users/PC MAROC/supracare_web/src/assets/img6.jpg');
  background-size: cover;
  background-position: center;
  color: rgb(29, 22, 77);
  padding: 150px 300px;
  font-size: 14px;
  margin: 0 auto;
  text-align: center;
  border-radius: 2px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 1000px;
  z-index: 1;
}

.breadcrumb {
  font-size: 12px;
  color: #555;
  margin-top: 20px;
}

.breadcrumb a {
  color: #0c0c0c;
  text-decoration: none;
  font-weight: bold;
}

.breadcrumb a:hover {
  text-decoration: underline;
}

.supracare-description {
  padding: 20px 200px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  margin-top: 0px;
  font-family: 'Open Sans', sans-serif;
}

.supracare-description h2 {
  color: #4c4a4d;
  font-size: 1.8rem;
  margin-bottom: 15px;
  font-family: 'Merriweather', serif;
}

.supracare-description p {
  font-size: 1.1rem;
  line-height: 1.75;
  color: #333;
  margin-bottom: 20px;
  font-family: 'Open Sans', sans-serif;
}

@media (max-width: 768px) {
  .brands-title {
    font-size: 2rem;
  }

  .supracare-description {
    padding: 20px;
  }

  .supracare-description h2 {
    font-size: 1.5rem;
  }

  .supracare-description p {
    font-size: 1rem;
  }
}


/* Responsive pour les petits écrans */
@media (max-width: 768px) {
  .brands-title {
    font-size: clamp(1.5rem, 5vw, 1rem);
    padding: 100px 0px;
  }

  .breadcrumb {
    font-size: 0.9rem;
  }

  .supracare-description {
    padding: 20px;
  }

  .supracare-description h2 {
    font-size: 1.5rem;
  }

  .supracare-description p {
    font-size: 1rem;
  }
}
</style>
